import { Typography } from '@mui/material'
import { EthAddress } from '@xylabs/sdk-js'
import { EthAccountButton, FlexBoxProps, useAsyncEffect } from '@xylabs/sdk-react'
import { useState } from 'react'

import { useGeotoken } from '../../Contexts'
import { Property } from '../Property'

const OwnerProperty: React.FC<FlexBoxProps> = (props) => {
  const geotoken = useGeotoken()

  const onTransfer = () => {
    console.log('Transfer')
  }

  const [owner, setOwner] = useState<EthAddress | null>()
  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      const data = await geotoken?.getOwner()
      if (!isMounted()) return
      setOwner(data)
    },
    [geotoken],
  )

  return (
    <Property
      actions={[{ disabled: true, name: 'Transfer', onClick: onTransfer }]}
      title="Owner"
      value={owner === null ? null : owner?.toString()}
      {...props}
    >
      {owner === undefined ? (
        <div />
      ) : owner ? (
        <EthAccountButton variant="outlined" address={owner} addressLength="auto" />
      ) : (
        <Typography variant="caption">None</Typography>
      )}
    </Property>
  )
}

export default OwnerProperty
